<ppl-app-container>
  <div class="centered-container">
    <div class="centered-container-content">
      <div class="error-content">
        <div class="col-text">
          <div class="title">Oops... Error 404</div>
          <div class="subtitle">It appears that you have reached a page that is no longer available.</div>
          <div class="go-to-home">
            <a routerLink="/"
               pplButton
               pplButton1
               pplButtonLarge
               pplButtonBold>Go to home</a>
          </div>
        </div>
        <div class="col-image">
          <img src="{{ errorImageUrl }}">
        </div>
      </div>
    </div>
  </div>
</ppl-app-container>
